import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import LoadingSpinner from "components/loading/LoadingSpinner";
import { authSelector } from "services/auth/authSlice";

const Home = () => {
  const { isAuthenticated } = useSelector(authSelector);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <>
      { loading ?
        <>
          <LoadingSpinner/>
        </>
        : <>
          { isAuthenticated ?
            <>
              <h1>Herzlich willkommen beim Wolters Kluwer Account Service</h1>
              <p>Mit Ihrem persönlichen Account haben Sie die Möglichkeit Ihre Sucheinstellungen und Newsletter zu verwalten.</p>
            </>
            : <>
              <h1>Wilkommen bei Wolters Kluwer</h1>
              <p>Dieser Bereich ist nur für registrierte Benutzer nutzbar. Bitte klicken sie oben auf den Anmelden-Link um sich bei einer unserer Anwendungen anzumelden.</p>
              <p>Zu unserer auch für Gast-Benutzer zugänglichen Rechercheplattform <a href={"https://research.wolterskluwer-online.de/"}>Wolters Kluwer Online</a> gelangen sie hier.</p>
              <p>Bei weiteren Fragen können sie <a href={"/kontakt"}>hier</a> Kontakt aufnehmen.</p>
              </>
          }
        </>
      }
    </>
  );
}

export default Home;
